<template>
  <div>
    <v-list class="blue lighten-4" v-if="this.filteredLocations.length > 0">
      <v-list-item v-for="item in this.filteredLocations" :key="item.post_url" class="blue lighten-4" @click="openSocialEventDialog(item)">
        <v-list-item-content>
          <v-list-item-title style="text-transform: capitalize; white-space: pre-wrap">{{ item.short_title }}</v-list-item-title>
          <v-list-item-subtitle style="text-transform: capitalize; white-space: pre-wrap">{{ formattedLocationName(item.location_id.name) }}</v-list-item-subtitle>
          <div style="display: flex; justify-content: center; margin-left: 4px; text-wrap: avoid" v-if="item.timeframe">
            <v-list-item-subtitle>{{ item.timeframe }} </v-list-item-subtitle>
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list class="blue lighten-4" v-else>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="my-2">No Community Data Here</v-list-item-title>
          <v-list-item-title class="my-2">Try Widening Your View</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <SocialEventDialog></SocialEventDialog>
  </div>

</template>

<script>
import {store} from "@/store";
import SocialEventDialog from "@/components/SocialEventDialog.vue";
import {gmapApi} from "vue2-google-maps";

export default {
  name: 'SocialData',
  components: {SocialEventDialog},
  props: ['drawerOpen'],
  data() {
    return {
      socialData: [],
      filteredLocations: '',
      addEventDialogVisible: false,
    };
  },
  computed: {
    store() {
      return store
    },
    getCurrentMapBounds() {
      return store.state.currentMapBounds;
    },
    google: gmapApi,
  },
  watch: {
    getCurrentMapBounds: {
      handler: async function (newVal) {
        if (newVal) {
          this.filteredLocations = store.state.socialData.filter(event => {
            const position = new this.google.maps.LatLng(event.location_id.position.lat, event.location_id.position.lng);
            return newVal.contains(position);
          });
        }
      }
    },
    filteredLocations: {
      handler: async function (newVal) {
        if (newVal[0]) {
          let allSame = newVal.every(obj => obj.location_id.id === newVal[0].location_id.id);
          if (allSame) {
            this.$emit('openDrawer')
          }
        }
      }
    }
  },
  methods: {
    closeAddEventDialog() {
      this.addEventDialogVisible = false
    },
    formattedLocationName(locationName) {
      let locationNameArray = locationName.split(", ");
      if (locationNameArray.length === 2) {
        if (locationNameArray[0] === locationNameArray[1]) {
          return locationNameArray[0]
        } else {
          return locationName
        }
      } else {
        return locationName
      }
    },
    openSocialEventDialog(itemData) {
      console.log(itemData)
      store.commit('setSocialEvent', itemData)
    }
  },
  async mounted() {
    await store.dispatch('getSocialData')
    this.filteredLocations = store.state.socialData.filter(event => {
      const position = new this.google.maps.LatLng(event.location_id.position.lat, event.location_id.position.lng);
      return this.getCurrentMapBounds.contains(position);
    });
    // this.filteredLocations = store.state.socialData
  },
};
</script>

<style scoped>

</style>